// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlockedView__container-abad1a {
  max-height: 620px;
  height: 100%;
}

.BlockedView__content-e73e4a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.BlockedView__button-back-cde3e6 {
  position: absolute;
  top: 20px;
  inset-inline-start: 20px;
}

.BlockedView__title-c87e00 {
  padding: 16px 0;
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  color: var(--base-110);
  text-align: center;
}

.BlockedView__subtitle-b957b8 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-120);
  text-align: center;
}

.BlockedView__logo-c95ee4 {
  width: 120px;
  height: 120px;
  margin: 24px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/BlockedView/BlockedView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,wBAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  max-height: 620px;\n  height: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.button-back {\n  position: absolute;\n  top: 20px;\n  inset-inline-start: 20px;\n}\n\n.title {\n  padding: 16px 0;\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  color: var(--base-110);\n  text-align: center;\n}\n\n.subtitle {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-120);\n  text-align: center;\n}\n\n.logo {\n  width: 120px;\n  height: 120px;\n  margin: 24px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BlockedView__container-abad1a`,
	"content": `BlockedView__content-e73e4a`,
	"button-back": `BlockedView__button-back-cde3e6`,
	"buttonBack": `BlockedView__button-back-cde3e6`,
	"title": `BlockedView__title-c87e00`,
	"subtitle": `BlockedView__subtitle-b957b8`,
	"logo": `BlockedView__logo-c95ee4`
};
module.exports = ___CSS_LOADER_EXPORT___;
